import AIPrompt from 'models/AIPrompt';

export type Source = { attachmentId: string; filename: string; displayId: number };

export type Section = {
  title: string;
  attachmentIds: string[];
  content: ContentType[];
};

export type ContentType = { text: string; attachmentIds?: string[]; children?: ContentType[] };

export enum AIArtifactType {
  SUMMARY = 'summary',
  COMPARISON = 'comparison',
}

export interface AIArtifactOptions {
  id: string;
  type: string;
  data: unknown;
  createdAt: Date | null;
  createdBy: {
    id: string;
    fullName: string;
    group?: string;
  };
  aiPrompt: AIPrompt;
}

/**
 * @class AIArtifact
 * @classdesc Represents an AI-generated artifact in the system
 * @property {string} id - The artifact's id
 * @property {string} type - The artifact's type
 * @property {unknown} data - The artifact's data
 * @property {string | null} createdAt - The artifact's creation date
 * @property {User | null} createdByUser - The user who created the artifact
 * @property {unknown} aiPrompt - The artifact's AI prompt
 * @param {Partial<AIArtifactOptions>} [options={}]
 */
export default class AIArtifact {
  id: string;
  type: string;
  data: unknown;
  createdAt: Date | null;
  createdBy: {
    id: string;
    fullName: string;
    group?: string;
  } | null;
  aiPrompt: AIPrompt | null;

  constructor(options?: Partial<AIArtifactOptions>) {
    const opts = { ...options };
    this.id = opts.id || '';
    this.type = opts.type || '';
    this.data = opts.data || {};
    this.createdAt = opts.createdAt || null;
    this.createdBy = opts.createdBy || null;
    this.aiPrompt = opts.aiPrompt ? new AIPrompt(opts.aiPrompt) : null;
  }

  serialize() {
    return {
      id: this.id,
      type: this.type,
      data: this.data,
      createdAt: this.createdAt,
      createdBy: this.createdBy,
      aiPrompt: this.aiPrompt,
    };
  }
}
